import { DropDown } from 'src/app/shared/model/base-model';
import { OnInit, Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { WoOrderServiceService } from '../wo-order-service.service';



@Component({
    selector: 'sf-wo-order-service-dropdown',
    templateUrl: './wo-order-service-dropdown.component.html',
    styleUrls: ['./wo-order-service-dropdown.component.scss']
})

export class WoOrderServiceDropdownComponent implements OnInit, OnChanges{

    public list : DropDown[];
    @Input() placeHolderLanguage: string;
    public selectedItem: DropDown;

    @Input() id: string;
    @Input() languageCode: string = "pt-BR";
    @Input() disabled: boolean = false;
    @Output() chosedItem = new EventEmitter();

    constructor(  private woOrderServiceService: WoOrderServiceService){ }

    ngOnInit(): void {
        this.getList();

    }

    ngOnChanges(): void {
        this.getList();
    }

    getList() {

        if (this.list !== null){
            this.woOrderServiceService.getOrderServiceDropDownList(this.languageCode).subscribe(
            {
                next: (res) => {
                    if (res)
                        this.list = res.data;
                },
                error: (err) => {
                    console.log(`WoOrderServiceDropDown - getList : ${err}.`);
                }
            });
        }
        this.setSelectedItem();
      }

    setSelectedItem(){
        if (this.list !== null && this.id !== null && this.id !== undefined){
            this.selectedItem = this.list.find(x => x.id == this.id);
            if (this.selectedItem == null || this.selectedItem.id == undefined)
            {
                this.selectedItem = this.list[0];
                this.feedback();
            }
        }
    }

    feedback(){
        this.chosedItem.emit(this.selectedItem)
    }

}
